
.Headline {
    letter-spacing: -0.03em;
    font-weight: 700;
    margin: 0 0 0.1em 0;

    &.isSizeMd {
        font-size: 1.625rem;
        line-height: 1.1;

        @media (min-width: 768px) {
            font-size: 2rem;
            line-height: 1.1;
        }
    }

    &.isSizeLg {
        font-size: 1.875rem;
        line-height: 1.25;

        @media (min-width: 640px) {
            font-size: 2.25rem;
            line-height: 1.1;
        }

        @media (min-width: 768px) {
            font-size: 2.6875rem;
            line-height: 1;
        }

        @media (min-width: 1024px) {
            font-size: 2.6875rem;
            line-height: 1;
        }
    }

    &.isSizeXl {
        font-size: 2.625rem;
        font-weight: 800;
        line-height: 1.1;

        @media (min-width: 640px) {
            font-size: 2.625rem;
            line-height: 1.25;
        }

        @media (min-width: 768px) {
            font-size: 3rem;
            line-height: 1;
        }

        @media (min-width: 1024px) {
            font-size: 3.75rem;
            line-height: 1;
        }
    }
}

